enum CompanyType {
    SoleTrader, Fleet
}

export {CompanyType};